import { render, staticRenderFns } from "./FormPayment.vue?vue&type=template&id=37f502f2&"
import script from "./FormPayment.vue?vue&type=script&lang=js&"
export * from "./FormPayment.vue?vue&type=script&lang=js&"
import style0 from "./FormPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports